module.exports = __webpack_public_path__ + "prod/20260929161836/img/smallProgram.e5352668.jpg";